'use client';

import { useState, useEffect } from 'react';

export default function Template({ children }: { children: React.ReactNode }) {
  // Removed loader logic
  return (
    <>{children}</>
  );
} 